exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cockpit-dialog__close[data-v-6d5e0ae6]{background-color:var(--dialogCloseBg);border-radius:3.47px}.cockpit-dialog .dialog-container[data-v-6d5e0ae6]{padding:20px;background-image:var(--dialogBgImg);background-repeat:no-repeat;background-size:100% 100%}", ""]);

// exports
